import { render, staticRenderFns } from "./businessLimitWarning.vue?vue&type=template&id=14a4e09c&scoped=true"
import script from "./businessLimitWarning.vue?vue&type=script&lang=ts"
export * from "./businessLimitWarning.vue?vue&type=script&lang=ts"
import style0 from "./businessLimitWarning.vue?vue&type=style&index=0&id=14a4e09c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a4e09c",
  null
  
)

export default component.exports